import { MessageBox } from 'element-ui'
import { h } from '@ve-pro/utils/h'
import i18n from '@/lang'
import store from '@pt/store'
import _ from 'lodash'
import { TrialScopePermission, TrialScope } from '@pt/config/trial'
import router from '@pt/router'
import { isEnterpriseUser } from '@pt/components/grant-dialog/utils'
// import { isCNSuffix } from '@com/utils/url'
import { websiteHost } from '@/config/host'
import { handleTrial } from '@pt/views/layout/components/subscribe-tips/utils'

export function navigateToPayment() {
  const userInfo = _.get(store, 'state.user.partnerInfo') || {}
  let accountType = 0
  if (isEnterpriseUser(userInfo.category)) {
    accountType = 1
  }

  const url = router.resolve({
    name: 'subscription-plans',
    query: {
      accountType: accountType,
    },
  }).href
  window.open(url, '_blank')
}

export function locationToMindworks() {
  const url = `${websiteHost}/contact`
  window.open(url, '_blank')
}

// 申请跳转订阅确认弹窗
/**
 *
 * @param {*} config
 * config.title 定制确认弹窗标题
 * config.permissionKey 确认弹窗目标逻辑权限key，无权限key默认提示联系销售弹窗
 */
export function subscribeConfirm(config) {
  // 确认弹窗文案配置
  const subscribeMessageConfig = {
    title:
      i18n.t(config && config.title ? config.title : '') ||
      i18n.t('playTurbo.trial.applyTrial.dialog.forbiden'),
    content: i18n.t('playTurbo.whole.notsubscribed.service'),
    confirm: i18n.t('playTurbo.payment.selectPackage.contract.dialog.title'),
    cancel: i18n.t('playTurbo.whole.cancel'),
  }

  // 根据config的权限key判断是否目标试用场景
  function checkIsTargetTrailByPermission() {
    const permissionKey =
      config && config.permissionKey ? config.permissionKey : ''
    const permissions = permissionKey ? permissionKey.split(',') : []
    const userinfo = _.get(store, 'state.user.info') || {}
    const scopeNum = Number(userinfo.trial_scope || 0)
    // 是否有套餐记录
    // const hasGrantRecord = userinfo.has_grant_record || false
    // const hasPlan = this.userInfo.plans.length > 0
    const toPl = permissions.some((key) =>
      TrialScopePermission.Pl.some((val) => val === key),
    )
    const toVideo = permissions.some((key) =>
      TrialScopePermission.Video.some((val) => val === key),
    )
    // eslint-disable-next-line no-bitwise
    const canTrialPl = (scopeNum | TrialScope.Pl) === scopeNum
    // eslint-disable-next-line no-bitwise
    const canTrialVideo = (scopeNum | TrialScope.Video) === scopeNum
    // eslint-disable-next-line no-bitwise
    const canTrialPlVideo = (scopeNum | TrialScope.PlVideo) === scopeNum
    // 是否免费试用目标场景
    // 1.目标pl权限且试用权限为1或者3
    // 2.目标video权限且试用权限为2或者3
    const isTrialTarget =
      (canTrialPl && toPl) ||
      (canTrialVideo && toVideo) ||
      (canTrialPlVideo && (toPl || toVideo))
    // 全新用户
    if (canTrialPlVideo) {
      subscribeMessageConfig.title = i18n.t(
        'playTurbo.trial.applyTrial.dialog.title',
      )
      subscribeMessageConfig.content = i18n.t(
        'playTurbo.account.subscribe.free.tips',
      )
      subscribeMessageConfig.confirm = i18n.t('playTurbo.whole.apply')
      subscribeMessageConfig.cancel = i18n.t('playTurbo.whole.cancel')
    }

    return isTrialTarget
  }

  checkIsTargetTrailByPermission()

  // 通过config配置标题，兼容已有逻辑
  if (config && config.title) {
    subscribeMessageConfig.title = config.title || subscribeMessageConfig.title
    subscribeMessageConfig.content =
      config.content || subscribeMessageConfig.content
    subscribeMessageConfig.confirm =
      config.confirm || subscribeMessageConfig.confirm
    subscribeMessageConfig.cancel =
      config.cancel || subscribeMessageConfig.cancel
  }
  MessageBox.confirm(
    subscribeMessageConfig.content,
    subscribeMessageConfig.title,
    {
      confirmButtonText: subscribeMessageConfig.confirm,
      cancelButtonText: subscribeMessageConfig.cancel,
      type: 'warning',
      center: true,
      customClass: 'apply-confrim-dialog',
    },
  )
    .then(() => {
      if (config.callback) {
        config.callback()
      } else {
        handleTrial()
        // if (isTargetTrail) {
        //   setTimeout(() => {
        //     store.dispatch('pt/trial/toggleDialogVisible', '', true)
        //   }, 300)
        // } else {
        //   navigateToPayment()
        // }
        // else if (!isCNSuffix()) {
        //   navigateToPayment()
        // }
      }
    })
    .catch(() => {
      //
    })
}
// firefox用户提醒弹窗
export function subscribeFirefox() {
  MessageBox({
    title: `${i18n.t('playTurbo.whole.hint')}/Notice`,
    message: h('div', undefined, [
      h('p', undefined, '建议您使用Google Chrome浏览器来获取最佳使用体验。'),
      h(
        'p',
        undefined,
        'We recommend using Google Chrome for the best user experience.',
      ),
    ]),
    showCancelButton: false,
    confirmButtonText: i18n.t('playTurbo.whole.gotit'),
    type: 'warning',
    customClass: 'apply-confrim-dialog firefox-dialog',
  }).catch(() => {})
}
